{
  "END_USER": "Utente finale",
  "MFA_REQUIRED": "Mfa richiesto",
  "COMPANY_INFORMATION": "Informazioni sull'azienda",
  "COMPANY_NAME": "Nome azienda",
  "ADDRESS1": "Via/Strada",
  "ADDRESS2": "Indirizzo",
  "ZIP": "Codice postale",
  "CITY": "Città",
  "ORG_NUMBER": "Partita iva",
  "EMAIL_ADDRESS": "Email",
  "TELEPHONE": "Telefono",
  "WEBADDRESS": "Sitio web",
  "QUOTATION": "Offerta",
  "NAME": "Nome",
  "CUSTOMER": "Cliente",
  "YOUR_REFERENCE": "Vostro referente",
  "PAYMENT_TERMS": "Termini di pagamento",
  "DATE": "Data",
  "EXPIRE_DATE": "Data di scadenza",
  "OUR_REFERENCE": "Nostro referente",
  "DELIVERY_TERMS": "Termini di spedizione",
  "NOTES": "Note",
  "PRICE_SUMMARY": "Prezzi",
  "ART_NO": "Numero articolo",
  "DESCRIPTION": "Descrizione",
  "QUANTITY": "Quantità",
  "PRICE": "Prezzo",
  "DISCOUNT": "Sconto",
  "DISCOUNTED_PRICE": "Prezzo netto",
  "TOTAL_PRICE": "Prezzo totale",
  "TOTAL_PRICE_AFTER_DISCOUNT": "Prezzo totale con sconto",
  "NEW_PRODUCTS": "Nuovi prodotti",
  "MY_ACCOUNT": "Il mio account",
  "PRICE_LIST": "Listino prezzi",
  "PARTIAL_DELIVERY_EXPECTED": "Consegna parziale, prima consegna {{date}}",
  "ENTRY_IN_PROGRESS": "Inserimento in corso",
  "ENTERED": "Inserito",
  "PICKING_IN_PROGRESS": "Prelevamento in corso",
  "INVOICED": "Fatturato",
  "TOP_PRODUCTS": "Prodotti principali",
  "NOT_ADD_BROCHURES": "I do not want brochures",
  "ADD_BROCHURES": "Add brochures",
  "BROCHURES_DECISION_NECESSARY": "Brochures decision necessary",
  "SPARE_PARTS": "Ricambi",
  "TOTAL_VAT_INCLUDED": "Totale IVA inclusa: ",
  "VAT_PRECENTAGE": "IVA %",
  "VAT_VALUE": "Valore IVA: ",
  "SAVE_AND_EMAIL_QUOTATION": "Salva e invia per email",
  "TO_BE_PHASED_OUT": "In fase di eliminazione",
  "TARIFF_CODE": "Codice tariffario",
  "REPLACES_NUMBER": "Sostituisce numero",
  "REPLACES_PRODUCT": "Sostituisce il prodotto",
  "NEWS_BANNER": "Nuovo",
  "CAMPAIGN_UNTIL": "Campagna fino al",
  "NEW_PRICE_FROM": "Nuovo prezzo dal",
  "PRESELECTED_CUSTOMER_ID": "ID cliente preselezionato",
  "CHANGE_ACCOUNT": "Cambia account",
  "CONTACT_YOUR_SALES_REPRESENTATIVE": "Contatta il tuo rappresentante commerciale"
}
